import { ReadonlyRepositoryListService, Result } from '@softline/core';
import { computed, inject, Injectable } from '@angular/core';
import { PeriodRepository } from '../repositories/period.repository';
import { Period } from '../types/period';

@Injectable()
export class PeriodService extends ReadonlyRepositoryListService<
  Period,
  Result<Period[]>,
  null
> {
  override params = computed(() => {
    return null;
  });

  constructor() {
    super(inject(PeriodRepository));
  }

  protected override getItems(result: Result<Period[]> | null | undefined): Period[] {
    return result as any;
  }
}
